import { useEffect, useMemo, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import DataCategoryModules, {
  DataCategoryModulesRef,
} from '../health-data-categories/data-category-modules';
import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import { useGetHealthData } from '../../use-health-data';

interface HealthDataContentProps {
  setParams: (params: Record<string, string>) => void;
}

export default function HealthDataContent({ setParams }: HealthDataContentProps) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const isEditMode = params.get('edit') === 'true';
  const dataCategoryModulesRef = useRef<DataCategoryModulesRef>(null);
  const toast = useToast();

  const { mappedCategories, isError, isInitiallyFetching } = useGetHealthData();

  useEffect(() => {
    if (isError) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error Loading Health Data',
        description: 'We encountered an issue loading your health data. Please try again later.',
        status: 'error',
      });
    }
  }, [isError, toast]);

  const categories = useMemo(
    () => mappedCategories.map(category => ({
      ...category,
      onReviewClick: () => {
        navigate('/health-data', { state: { categoryName: category.name } });
      },
    })),
    [mappedCategories, navigate],
  );

  return (
      <DataCategoryModules
        ref={dataCategoryModulesRef}
        categories={categories}
        isEditMode={isEditMode}
        isInitiallyFetching={isInitiallyFetching}
      />
  );
}
